import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AppStorageService } from '../services/app-storage.service';

export const HeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const appStorageService = inject(AppStorageService);
  const language = appStorageService.languagePreference() || 'en';
  const isPPUOriginUrl = (req: any) => {
    if (req.url.startsWith(environment.API_ROOT)) {
      return true;
    }
    return false;
  };

  if (isPPUOriginUrl(req)) {
    req = req.clone({
      setHeaders: {
        language: language,
        ClientType: 'customer_mobile',
      },
    });
  }
  return next(req);
};
